import { memo, useMemo } from 'react';
import { observer } from 'mobx-react';

import SectionTitle from '../../../../../components/Titles/SectionTitle';
import CertificationCard from './CertificationCard/CertificationCard';
import SampleVideo from './SampleVideo/SampleVideo';
import UsersVoice from './UsersVoice/UsersVoice';
import Courses from './Courses/Courses';

import './style.scss';

const IntroductionTopPage = observer(({ contentIntroduction }) => {
    // function convert data
    const convertDataComponent1 = (data = {}) => {
        const content = Array.isArray(data?.content) && data?.content?.length > 0
            ? data?.content?.filter(item => !!item)
            : [];

        const image = Array.isArray(data?.image) && data?.image?.length > 0
            // ? data?.image?.filter(item => !!item?.url)
            ? data?.image
            : [];

        return {
            ...data,
            title: data?.title || '',
            explanation1: data?.explanation1 || '',
            explanation2: data?.explanation2 || '',
            buttonName: data?.buttonName || '',
            tag: data?.tag || '',
            content,
            image
        };
    };

    const convertDataComponent2 = (data = {}) => {
        const boxs = Object.entries(data)
            .filter(([key]) => key.startsWith('box'))
            .map(([_, box]) => {
                return {
                    title: box?.title || '',
                    content: box?.content || '',
                    image: {
                        key: box?.image?.key || '',
                        url: box?.image?.url || ''
                    }
                };
            });
        return {
            boxs
        };
    };

    const convertDataComponent3 = (data = {}) => {
        const sampleVideos = Object.entries(data)
            .filter(([key]) => key.startsWith('sampleVideo'))
            .map(([_, value]) => {
                return {
                    explanatory: value?.explanatory || '',
                    video: {
                        key: value?.video?.key || '',
                        url: value?.video?.url || '',
                        thumbnailUrl: value?.video?.thumbnailUrl || '',
                        isActive: !!value?.video?.isActive
                    }
                };
            });

        return {
            title: data?.title || '',
            content: data?.content || '',
            sampleVideos
        };
    };

    const convertDataComponent4 = (data = {}) => {
        const boxs = Object.entries(data)
            .filter(([key]) => key.startsWith('box'))
            .map(([_, box]) => {
                return {
                    heading: box?.heading || '',
                    image: {
                        key: box?.image?.key || '',
                        url: box?.image?.url || ''
                    }
                };
            });

        return {
            title: data?.title || '',
            boxs
        };
    };

    // const 
    const [component1, component2, component3, component4] = useMemo(() => {
        const com1Data = convertDataComponent1(contentIntroduction?.component1);
        const com2Data = convertDataComponent2(contentIntroduction?.component2);
        const com3Data = convertDataComponent3(contentIntroduction?.component3);
        const com4Data = convertDataComponent4(contentIntroduction?.component4);

        return [com1Data, com2Data, com3Data, com4Data];
    }, [
        contentIntroduction?.component1,
        contentIntroduction?.component2,
        contentIntroduction?.component3,
        contentIntroduction?.component4
    ]);


    return (
        <section id='id-section-introduction' className='section-introduction'>
            <div className='container'>
                <div className='section-wrapper'>
                    {/* Intro */}
                    <div className='intro'>
                        {/* Title */}
                        {(component1?.title || component1?.explanation1 || component1?.explanation2) && (
                            <div className='intro-header'>

                                {component1?.title && (
                                    <div className='intro-title'>
                                        <SectionTitle title={component1?.title} />
                                    </div>
                                )}

                                {component1?.explanation1 && (
                                    <div className='intro-sub-title sub-title'>
                                        {component1?.explanation1}
                                    </div>
                                )}

                                {component1?.explanation2 && (
                                    <div className='intro-desc desc' style={{ whiteSpace: 'pre-line' }}>
                                        {component1?.explanation2 || ''}
                                    </div>
                                )}
                            </div>
                        )}

                        {/* Courses and img */}
                        <Courses data={component1} />

                        {/* Certification */}
                        <div className='certification-box'>
                            {
                                Array.isArray(component2?.boxs) && component2?.boxs?.length > 0 && component2?.boxs
                                    ?.filter(item => item?.title || item?.content || item?.image?.url)
                                    ?.map((item, index) => (
                                        <CertificationCard key={index} certificaItem={item} />
                                    ))
                            }
                        </div>
                    </div>

                    {/* Sample Movie */}
                    <SampleVideo data={component3} />
                </div>
            </div>

            <div style={{
                overflowX: 'hidden'
            }}>
                <div className='container'>
                    {/* Users voice */}
                    <UsersVoice data={component4} />
                </div>
            </div>
        </section>
    )
})

export default memo(IntroductionTopPage);
